export default __webpack_public_path__ + "static/media/education-img-cover-carat.bcf13f45.webp";